import { Outlet } from "react-router-dom";
import { Providers } from "@/components/providers";

export function RootLayout() {
    return (
        <div className="font-sans antialiased">
            <Providers>
                <Outlet />
            </Providers>
        </div>
    );
}
